import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';

export function BurokDownloadPromo() {
  return (
    <div className="hidden md:flex items-center gap-3 px-5 py-2.5 rounded-xl bg-gradient-to-r from-white/15 via-white/20 to-white/15 backdrop-blur-md border border-white/30 hover:from-white/20 hover:via-white/25 hover:to-white/20 hover:border-white/40 hover:shadow-lg hover:shadow-white/10 transition-all duration-300 group cursor-pointer relative overflow-hidden">
      {/* Effet de brillance animé */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000"></div>
      </div>
      
      <div className="relative flex-shrink-0 z-10">
        <img
          src="/assets/images/BUROKLOGOTWITTER.png"
          alt="Burok Logo"
          className="h-8 w-8 object-contain group-hover:scale-110 transition-transform duration-300"
        />
      </div>
      
      <div className="flex flex-col z-10">
        <span className="text-white text-sm font-bold leading-tight drop-shadow-sm">
          Téléchargez l'app
        </span>
        <span className="text-white/90 text-[11px] font-medium leading-tight">
          Burok disponible maintenant
        </span>
      </div>
      
      <div className="relative z-10">
        <ArrowDownTrayIcon className="h-5 w-5 text-white group-hover:text-white group-hover:scale-110 group-hover:translate-y-0.5 transition-all duration-300" />
      </div>
    </div>
  );
}

